import SituacaoCertidao, { SITUACAO_CERTIDAO } from '@/dominio/SituacaoCertidao';
import SituacaoCertidaoJulgamentoBusiness from '@/dominio/SituacaoCertidaoJulgamentoBusiness';
import BusinessError from '@/util/BusinessError';
import { faFile, faFileAlt, faFileSignature } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Assignment from '@mui/icons-material/Assignment';
import { makeObservable, observable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroCertidaoPendente extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    tamanhoIcone = '24px';
    opacidadeIcone = '0.7';
    paddingIcone = '2px';

    get label() {
        return 'Situação de certidão';
    }

    getIconeFiltroRapido() {
        return <Assignment />;
    }

    opcoesFiltro = FiltroCertidaoPendente.#carregarOpcoes();

    filtroRapido = {
        opcoes: this.getOpcoesFiltro('valor', 'cor')
    };

    static #carregarOpcoes() {
        return [
            {
                valor: SITUACAO_CERTIDAO.NAO_CRIADA.id,
                cor: SITUACAO_CERTIDAO.NAO_CRIADA.cor,
                icone: (
                    <FontAwesomeIcon
                        icon={faFile}
                        style={{
                            width: this.tamanhoIcone,
                            height: this.tamanhoIcone,
                            color: SITUACAO_CERTIDAO.NAO_CRIADA.cor,
                            fillOpacity: this.opacidadeIcone,
                            padding: this.paddingIcone
                        }}
                    />
                )
            },
            {
                valor: SITUACAO_CERTIDAO.NAO_ASSINADA.id,
                cor: SITUACAO_CERTIDAO.NAO_ASSINADA.cor,
                icone: (
                    <FontAwesomeIcon
                        icon={faFileAlt}
                        style={{
                            width: this.tamanhoIcone,
                            height: this.tamanhoIcone,
                            color: SITUACAO_CERTIDAO.NAO_ASSINADA.cor,
                            fillOpacity: this.opacidadeIcone,
                            padding: this.paddingIcone
                        }}
                    />
                )
            },
            {
                valor: SITUACAO_CERTIDAO.ASSINADA.id,
                cor: SITUACAO_CERTIDAO.ASSINADA.cor,
                icone: (
                    <FontAwesomeIcon
                        icon={faFileSignature}
                        style={{
                            width: this.tamanhoIcone,
                            height: this.tamanhoIcone,
                            color: SITUACAO_CERTIDAO.ASSINADA.cor,
                            fillOpacity: this.opacidadeIcone,
                            padding: this.paddingIcone
                        }}
                    />
                )
            }
        ];
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        let situacao;

        try {
            situacao = SituacaoCertidaoJulgamentoBusiness.getSituacaoCertidaoJulgamento(registro);
        } catch (error) {
            if (!(error instanceof BusinessError)) {
                console.error(
                    `${SituacaoCertidao.MSG_ERRO_IDENTIFICACAO_SITUACAO_CERTIDAO} [${registro.numeroProcesso}]`
                );
            }

            return '';
        }

        return situacao.id;
    }

    getDescricao(valor) {
        return SituacaoCertidao.getDescricao(valor);
    }
}
